import { render, staticRenderFns } from "./EventDetailsUrlStep.vue?vue&type=template&id=b57356f2"
import script from "./EventDetailsUrlStep.vue?vue&type=script&lang=js"
export * from "./EventDetailsUrlStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports